<script setup lang="ts">
const props = defineProps<{
  profileSections: {
    key: string
    title: string
    icon: string
    url: string
  }[]
}>()

const { trackProfileMenuClick } = useGTM()

const onRouteClick = (menuItem: string) => {
  trackProfileMenuClick(menuItem)
}
</script>

<template>
  <div class="flex flex-col gap-4 rounded-xl bg-white shadow-xl">
    <div v-for="section in props.profileSections" :key="section.key">
      <NuxtLink
        :to="section.url"
        class="relative flex items-center px-4 py-3 hover:bg-mcd-secondary"
        @click="onRouteClick(section.key)"
      >
        <section class="flex items-center gap-4">
          <figure>
            <img class="h-full w-6" :src="section.icon" :alt="section.title" />
          </figure>
          <h4 class="text-sm">{{ section.title }}</h4>
        </section>
      </NuxtLink>
    </div>
  </div>
</template>

<style scoped>
.router-link-active {
  @apply bg-mcd-secondary;
}
.router-link-active::before {
  @apply absolute left-0  block h-full w-1 bg-mcd-main content-[''];
}
</style>
